export function findColumns() {
  const registrationNumber = { key: 'registrationNumber', header: 'Regnr', width: 10 }
  const make = { key: 'make', header: 'Merke', width: 15 }
  const model = { key: 'model', header: 'Modell', width: 15 }
  const engine = { key: 'engine', header: 'Motor', width: 20 }
  const year = { key: 'year', header: 'År', width: 10 }
  const driverName = { key: 'driverName', header: 'Sjåfør', width: 20 }
  const status = { key: 'status', header: 'Status', width: 15 }
  const actualDeliveryDate = { key: 'actualDeliveryDate', header: 'Løpetid', width: 10 }
  const plannedReturnDate = { key: 'plannedReturnDate', header: 'Avtaleslutt', width: 15 }
  const nextInspectionDate = { key: 'nextInspectionDate', header: 'EU-kontrollfrist', width: 15 }
  const replacementCar = { key: 'replacementCar', header: 'Kobling bestilling', width: 15 }
  const consolidatedInvoiceCode = { key: 'consolidatedInvoiceCode', header: 'Samlefaktura', width: 15 }
  const invoiceGroup = { key: 'invoiceGroup', header: 'Fakturagruppe', width: 15 }
  const vehicleType = { key: 'vehicleType', header: 'Biltype', width: 15 }
  const mainContactName = { key: 'mainContactName', header: 'Kontaktperson', width: 20 }
  const budgetNo = { key: 'budgetNo', header: 'Budsjett nr.', width: 10 }
  const fuel = { key: 'fuel', header: 'Drivstoff', width: 10 }
  const mileage = { key: 'mileage', header: 'KM stand', width: 15 }
  const simulatedMileage = { key: 'simulatedMileage', header: 'KM-simulert', width: 15 }
  const contractMileage = { key: 'contractMileage', header: 'Maks km', width: 15 }
  const deliveryDate = { key: 'deliveryDate', header: 'Estimert leveringsdato', width: 20 }

  return [
    registrationNumber,
    make,
    model,
    engine,
    year,
    driverName,
    status,
    actualDeliveryDate,
    plannedReturnDate,
    nextInspectionDate,
    replacementCar,
    consolidatedInvoiceCode,
    invoiceGroup,
    vehicleType,
    mainContactName,
    budgetNo,
    fuel,
    mileage,
    simulatedMileage,
    contractMileage,
    deliveryDate,
  ]
}
